import { createAction } from 'redux-actions'

const prefix = 'Config:'
export const SET_BASE_URL = `${prefix} Set base URL from environment.`
export const SET_API_URL = `${prefix} Set api url.`
export const SET_CHAT_APP_ID = `${prefix} Set chat app id.`

const setApiUrl = createAction(SET_API_URL)
export const setBaseUrl = createAction(SET_BASE_URL)
const setChatAppId = createAction(SET_CHAT_APP_ID)

export const actionCreators = {
  setBaseUrl,
  setApiUrl,
  setChatAppId,
}
